/** Non-component constants for the centred prompt card (kept out of the
 *  component module so Fast Refresh stays clean). */

/** Which body the card is showing. */
export type PromptMode = 'image' | 'text' | 'mesh';

export const MODE_LABELS: Record<PromptMode, string> = {
  image: 'Image to CAD',
  text: 'Text to CAD',
  mesh: 'Mesh to CAD',
};

/** Transparent-checkerboard fill for the empty upload well. */
export const CHECKER: React.CSSProperties = {
  backgroundImage:
    'repeating-conic-gradient(rgba(255,255,255,0.035) 0% 25%, transparent 0% 50%)',
  backgroundSize: '26px 26px',
};
